export default __webpack_public_path__ + "static/media/ratehub.1bfeb613.png";